import { SuccessPageComponent } from './app-modules/success-page/success-page.component';
import { NgModule, Component, ViewChild, ViewContainerRef, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { FormlyModule, FormlyFieldConfig, FormlyBootstrapModule, Field, FieldWrapper } from 'ng-formly';
import { AppComponent } from './app.component';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// File upload module
import { FileUploadModule } from 'ng2-file-upload';
// Cloudinary module
import { CloudinaryModule, CloudinaryConfiguration, provideCloudinary } from '@cloudinary/angular-4.x';
import cloudinaryConfiguration from './shared/config/cloudinary.config';
import * as cloudinary from 'cloudinary-core';
import { Angulartics2Mixpanel } from 'angulartics2';
import { AccessGroupService } from './shared/services/accessgroup.service';


//Formly Fields
import {
    DataElementSelect,
    DatePicker,
    DateRangePicker,
    EntityfieldMultipleSelect,
    EntityfieldSelect,
    CascadedLookup,
    EntityRecordSelectMultiple,
    EntitySelect,
    EntitySelectMultiple,
    FilterSelect,
    InputField,
    PagelayoutSelect,
    PicklistLookup,
    PicklistRadio,
    PicklistSelect,
    ReadonlyField,
    RepeatComponent,
    OptionSelect,
    OptionSelectMultiple,
    ComponentSelect,
    ComponentSelectMultiple,
    SearchlayoutSelect,
    SubEntity,
    TextAreaField,
    TimePicker,
    ToggleCheckbox,
    UserSelect,
    TypeaheadComponent
} from './shared/components/fields';

import { CustomFieldsModule } from './shared/components/fields/fields.module';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { Ng2BootstrapModule, DatepickerModule, AccordionModule, ModalModule, ProgressbarModule, TimepickerModule, BsDropdownModule, TabsModule, PopoverModule, TypeaheadModule } from 'ng2-bootstrap';


import { NAV_DROPDOWN_DIRECTIVES } from './shared/components/layout/navbar/nav-dropdown.directive';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/components/layout/sidebar/sidebar.directive';
import { AsideToggleDirective } from './shared/components/layout/aside/aside.directive';
import { BreadcrumbsComponent } from './shared/components/layout/breadcrumb/breadcrumb.component';
import { SideBarMenuComponent } from './shared/components/layout/sidebar/sidebar-menu.component';
import { TopBarMenuComponent } from './shared/components/layout/topbar/topbar-menu.component';
import { AccountApi, EntityApi, EntityfieldApi, EntityrecordApi, EntitycompactlayoutApi, EntitylistlayoutApi, EntitypagelayoutApi } from './shared/sdk/services/custom';

/* Routing Module */
import { AppRoutingModule } from './app.routing';

//Login
import { LoginComponent } from './app-modules/login/login.component';

//Layouts
import { FullLayoutComponent } from './shared/components/layout/full-layout/full-layout.component';
import { SimpleLayoutComponent } from './shared/components/layout/simple-layout/simple-layout.component';

// Import the SDK Module
import { SDKBrowserModule } from './shared/sdk';

import { LoopBackAuth } from './shared/sdk/services/core/auth.service';
import { PlatformApp } from './shared/services/app.service';

import { SelectModule } from 'ng2-select';
import { NgPipesModule } from 'ngx-pipes';
//import { LicenseManager } from "ag-grid-enterprise/main";
import { AppSettings } from './app.settings';
import { CacheService, CacheStoragesEnum } from 'ng2-cache/ng2-cache';
import { ValidationService } from './shared/services/validation.service';
import { WidgetsModule } from './shared/components/widgets/widgets.module';
import { WindowRef } from './shared/services/window.service';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { DynamicModule } from './app-modules/dynamic/dynamic.module';
import { EntityService } from './shared/services/entity.service';
import { SimpleNotificationsModule, PushNotificationsModule } from 'angular2-notifications';
import { NotificationsService, SimpleNotificationsComponent, PushNotificationsService } from 'angular2-notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PasswordResetComponent } from './app-modules/password-reset/password-reset.component';
import { ForgotPasswordComponent } from './app-modules/forgot-password/forgot-password.component';

@NgModule({
    declarations: [
        AppComponent,
        FullLayoutComponent,
        SimpleLayoutComponent,
        LoginComponent,
        SuccessPageComponent,
        NAV_DROPDOWN_DIRECTIVES,
        BreadcrumbsComponent,
        SideBarMenuComponent,
        TopBarMenuComponent,
        SIDEBAR_TOGGLE_DIRECTIVES,
        AsideToggleDirective,
        PasswordResetComponent,
        ForgotPasswordComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SimpleNotificationsModule.forRoot(),
        PushNotificationsModule,
        FormsModule,
        CommonModule,
        HttpModule,
        AccordionModule.forRoot(),
        AppRoutingModule,
        Ng2BootstrapModule,
        Ng2TableModule,
        InfiniteScrollModule,
        ModalModule.forRoot(),
        DatepickerModule.forRoot(),
        ProgressbarModule.forRoot(),
        TimepickerModule.forRoot(),
        TabsModule.forRoot(),
        PopoverModule.forRoot(),
        // Tell Angular we want the SDKBrowserModule to be available app wide
        SDKBrowserModule.forRoot(),
        FormsModule, ModalModule,
        BsDropdownModule.forRoot(),
        FormlyBootstrapModule,
        FormsModule,
        ReactiveFormsModule,
        CustomFieldsModule,
        WidgetsModule,
        TypeaheadModule.forRoot(),
        FormlyModule.forRoot({
            types: [
                // Used Always
                { name: 'user-select', component: UserSelect, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'datepicker', component: DatePicker, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'timepicker', component: TimePicker, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'input-field', component: InputField, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'textarea-field', component: TextAreaField, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'select-component', component: ComponentSelect, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'daterangepicker', component: DateRangePicker, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'repeatedsection', component: RepeatComponent },
                { name: 'subentity', component: SubEntity },

                //To be deprecated
                { name: 'cascaded-lookup', component: CascadedLookup, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'entityrecord-multiple', component: EntityRecordSelectMultiple, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'picklist-select', component: PicklistSelect, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'picklist-lookup', component: PicklistLookup, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'dataelement-select', component: DataElementSelect, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'pagelayout-select', component: PagelayoutSelect, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'searchlayout-select', component: SearchlayoutSelect, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'picklist-radio', component: PicklistRadio, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'readonly-field', component: ReadonlyField, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'select-options', component: OptionSelect, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'select-options-multiple', component: OptionSelectMultiple, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'select-filter', component: FilterSelect, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'select-component-multiple', component: ComponentSelectMultiple, extends: 'input', wrappers: ['fieldset', 'label'] },
                { name: 'typeahead', component: TypeaheadComponent, extends: 'input', wrappers: ['fieldset', 'label'] }

            ],
            //  validators: [{ name: 'required', validation: Validators.required }],
            validationMessages: [
                // { name: 'required', message: (err, field) => { return `${field.templateOptions.label} is required.` } },
                // { name: 'validateError', message: (err, field) => { return `Validate Failed: ${field.templateOptions.label} ${field.templateOptions.operation} ${field.templateOptions.checkerfield}` } },
                { name: 'required', message: 'Required Field' },
                { name: 'validateError', message: 'Validation Failed' },
                { name: 'invalidEmailAddress', message: 'Invalid Email Address' },
                { name: 'invalidPhoneNumber', message: 'Need 10 Digit Number' },
                { name: 'invalidPattern', message: 'Invalid Entry' },
                { name: 'invalidGeolocation', message: 'Invalid Coordinates lat,lng' },
                { name: 'maxlength', message: 'Maximum Length Exceeded.' },
                { name: 'not_matching', message: 'Password Not Matching' },
                { name: 'zipCode', message: 'ZIP code should be 5 characters' },
                { name: 'uniqueUsername', message: 'This username is already taken.' },
                { name: 'valueGreaterThanAllowed', message: 'Should be Lesser than or Equal to Allowed Value' },
                { name: 'valueGreaterThanOrEqualToAllowed', message: 'Should be Lesser than Allowed Value' },
                { name: 'valueNotEqualToAllowed', message: 'Should be equal to Allowed Value' },
                { name: 'valueLesserThanAllowed', message: 'Should be Greater than or Equal to Allowed Value' },
                { name: 'valueLesserThanOrEqualToAllowed', message: 'Should be Greater than Allowed Value' },
                { name: 'valueEqualToAllowed', message: 'Should not be equal to Allowed Value' },
            ],
        }),
        SelectModule,
        NgPipesModule,
        CloudinaryModule.forRoot(cloudinary, cloudinaryConfiguration),
        FileUploadModule,

        /**
    * StoreModule.provideStore is imported once in the root module, accepting a reducer
    * function or object map of reducer functions. If passed an object of
    * reducers, combineReducers will be run creating your application
    * meta-reducer. This returns all providers for an @ngrx/store
    * based application.
    */
        // StoreModule.provideStore(reducer),

        /**
         * @ngrx/router-store keeps router state up-to-date in the store and uses
         * the store as the single source of truth for the router's state.
         */
        //   RouterStoreModule.connectRouter(),

        /**
         * Store devtools instrument the store retaining past versions of state
         * and recalculating new states. This enables powerful time-travel
         * debugging.
         *
         * To use the debugger, install the Redux Devtools extension for either
         * Chrome or Firefox
         *
         * See: https://github.com/zalmoxisus/redux-devtools-extension
         */
        // StoreDevtoolsModule.instrumentOnlyWithExtension(),

    ],

    providers: [CacheService,
        LoopBackAuth,
        PlatformApp,
        // LicenseManager,
        AppSettings,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        WindowRef,
        AccountApi,
        EntityApi,
        EntityfieldApi,
        EntityrecordApi,
        EntitycompactlayoutApi,
        EntitylistlayoutApi,
        EntitypagelayoutApi,
        EntityService,
        NotificationsService,
        AccessGroupService,
        PushNotificationsService],

    bootstrap: [AppComponent],

    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {

    constructor(private appsettings: AppSettings) {
        // LicenseManager.setLicenseKey(appsettings.AGGRID_LICENSE);

    }

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts